import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "select-office mb-6 col-12" }

import TemperatureSensorVehicleAutoComplete from '@/components/TemperatureSensorChartParts/VehicleAutoComplete.vue';
import DepartmentAutoComplete from "@/components/AutoCompletes/DepartmentAutoComplete.vue";
import getDepartment from "@/types/responses/getDepartment";
import getVehicle from "@/types/responses/getVehicle";
import { reactive, computed } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchForm',
  props: {
    loading: { type: Boolean },
    windowInnerWidth: {},
    isDepartment: { type: Boolean }
  },
  emits: ['search'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const props = __props

const form = reactive({
  department: undefined as getDepartment | undefined,
  vehicle: undefined as getVehicle | undefined,
})

const changeSearchButton = computed(() => {
  return props.loading ? i18n.global.t('pages.common.button.loading') : i18n.global.t('pages.common.button.exec');
})

function handleClickSearch() {
  emits('search', form);
}

function clearForm() {
  form.department = undefined;
  form.vehicle = undefined;
}


return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { class: "d-flex" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: __props.windowInnerWidth > 800 ? 4 : 8
        }, {
          default: _withCtx(() => [
            _createVNode(DepartmentAutoComplete, {
              modelValue: form.department,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.department) = $event)),
              isUnaffiliated: !props.isDepartment,
              selectFirstIfOnlyOne: props.isDepartment
            }, null, 8, ["modelValue", "isUnaffiliated", "selectFirstIfOnlyOne"])
          ]),
          _: 1
        }, 8, ["cols"]),
        _createVNode(_component_v_col, {
          cols: __props.windowInnerWidth > 800 ? 4 : 8
        }, {
          default: _withCtx(() => [
            _createVNode(TemperatureSensorVehicleAutoComplete, {
              modelValue: form.vehicle,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.vehicle) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["cols"]),
        _createVNode(_component_v_col, {
          class: "d-flex align-end",
          cols: __props.windowInnerWidth > 800 ? 2 : 4
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              class: "ma-2 exec-btn",
              onClick: handleClickSearch,
              style: _normalizeStyle({
            backgroundColor: props.loading ? '#B3B8BB' : '',
          })
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(changeSearchButton.value), 1)
              ]),
              _: 1
            }, 8, ["style"]),
            _createVNode(_component_v_btn, {
              class: "ma-2 reset-btn",
              onClick: clearForm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.reset')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["cols"])
      ]),
      _: 1
    })
  ]))
}
}

})